import { useIdleTimer } from "react-idle-timer";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useKeycloak } from "@react-keycloak/web";
import "rsuite/dist/rsuite-no-reset.min.css";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Retail from "./Pages/Retail/index.jsx";
import axios from "axios";
import Layout from "./Components/Layout.jsx";
import Landing from "./Pages/Home/index.jsx";
import PageNotFound from "./Pages/404/index.jsx";
import Stock from "./Pages/Stock";
import Login from "./Components/Login/Login.jsx";
import Service from "./Pages/Complaint";
import Offtake from "./Pages/Offtake";
import Cards from "./Components/Cards/index.jsx";
import { WaterMarkProvider } from "./Components/WaterMark/WatermarkProvider.jsx";
import useDisableRightClickAndF12 from "./Pages/useDisableRightClickAndF12.jsx";
import screenShortsDisable from "./Pages/screenShortsDisable.jsx";
import { axInst } from "./Components/Login/Service.jsx";
import ProtectedRoute from "./Components/Login/ProtectedRoute.js";
import PipeLine from "./Pages/Pipeline/index.jsx";
import LeadSource from "./Pages/LeadSource/index.jsx";
import Swal from "sweetalert2";
import Wsr from "./Pages/Wsr/index.js";
import WsrMetrics from "./Pages/Wsr/WsrStatics/WsrMetrics.jsx";
import TqpLostCase from "./Pages/Wsr/WsrStatics/TqpLostCase.jsx";
import StateWiseOfftake from "./Pages/Wsr/WsrStatics/StateWiseOfftake.jsx";
import ILMCVPerformance from "./Pages/Wsr/WsrStatics/PerformanceDashboard.jsx";
import Customer360 from "./Pages/Customer360/Pvin.jsx";
import DealerReview from "./Pages/DealerReview/index.jsx";
import DealerDataUpload from "./Pages/DealerReview/DealerDataUpload/DealerDataUpload.jsx";
import SalesSuccess from "./Pages/SalesSuccess/index.jsx";
import Realization from "./Pages/Realization/index.js";
import ServiceCollabax from "./Pages/ServiceCollabax/index.jsx";
import DealerServiceCollabax from "./Pages/ServiceCollabax/DealerDashboard.jsx";
import Pvin from "./Pages/Pvin/index.jsx";
import index from "./Pages/PowerDeck/index.jsx";

const hourAgo = new Date().getTime() - 3600000;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      initialDataUpdatedAt: hourAgo,
    },
  },
});

function App() {
  useDisableRightClickAndF12();
  screenShortsDisable();
  const { keycloak } = useKeycloak();

  // const handleLogout = async () => {
  //   Swal.fire({
  //     title: "Do you want to logout?",
  //     text: "",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Logout",
  //     allowOutsideClick: false,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         const basicAuth =
  //           "Basic " +
  //           btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  //         await axInst.put(
  //           `${process.env.REACT_APP_API_URL}user-system-logs`,
  //           {},
  //           { withCredentials: true }
  //         );
  //         const username = sessionStorage.getItem("username");
  //         await axios.post(
  //           `${process.env.REACT_APP_API_URL}logout?user_id=${username}`,
  //           {},
  //           {
  //             headers: {
  //               Authorization: basicAuth,
  //             },
  //           }
  //         );
  //         sessionStorage.clear();
  //         sessionStorage.removeItem("token");
  //         keycloak.logout({ redirectUri: window.location.origin });
  //       } catch (error) {
  //         console.log(error.message);
  //       }
  //     }
  //   });
  // };
  // const handleLogoutIdeal = async () => {
  //   try {
  //     const basicAuth =
  //       "Basic " +
  //       btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  //     await axInst.put(`${process.env.REACT_APP_API_URL}user-system-logs`);
  //     const username = sessionStorage.getItem("username");
  //     await axios.post(
  //       `${process.env.REACT_APP_API_URL}logout?user_id=${username}`,
  //       {},
  //       {
  //         headers: {
  //           Authorization: basicAuth,
  //         },
  //       }
  //     );
  //     sessionStorage.clear();
  //     sessionStorage.removeItem("token");
  //     keycloak.logout({ redirectUri: window.location.origin });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleLogout = async () => {
    Swal.fire({
      title: "Do you want to logout?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Logout",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const basicAuth =
            "Basic " +
            btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
          await axInst.put(`${process.env.REACT_APP_API_URL}user-system-logs`);
          const username = localStorage.getItem("username");
          await axios.post(
            `${process.env.REACT_APP_API_URL}logout?user_id=${username}`,
            {},
            {
              headers: {
                Authorization: basicAuth,
              },
            },
          );
          localStorage.clear();
          localStorage.removeItem("token");
          keycloak.logout({ redirectUri: window.location.origin });
        } catch (error) {
          console.log(error.message);
        }
      }
    });
  };

  // const handleLogout = async () => {
  //   Swal.fire({
  //     title: "Do you want to logout?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Logout",
  //     allowOutsideClick: false,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         const basicAuth =
  //           "Basic " +
  //           btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

  //         await axInst.put(`${process.env.REACT_APP_API_URL}user-system-logs`);

  //         const username = localStorage.getItem("username");

  //         await axios.post(
  //           `${process.env.REACT_APP_API_URL}logout?user_id=${username}`,
  //           {},
  //           {
  //             headers: {
  //               Authorization: basicAuth,
  //             },
  //           }
  //         );

  //         // ✅ TELL ALL IFRAMES (XYZ APP) TO LOGOUT
  //         window.postMessage(
  //           { type: "XYZ_LOGOUT" },
  //           "*" // or xyz domain
  //         );

  //         // ✅ CLEAR ABC STORAGE
  //         localStorage.clear();
  //         sessionStorage.clear();

  //         // ✅ KEYCLOAK LOGOUT
  //         keycloak.logout({ redirectUri: window.location.origin });
  //       } catch (error) {
  //         console.log(error.message);
  //       }
  //     }
  //   });
  // };

  const handleLogoutIdeal = async () => {
    try {
      const basicAuth =
        "Basic " +
        btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
      await axInst.put(`${process.env.REACT_APP_API_URL}user-system-logs`);
      const username = localStorage.getItem("username");
      await axios.post(
        `${process.env.REACT_APP_API_URL}logout?user_id=${username}`,
        {},
        {
          headers: {
            Authorization: basicAuth,
          },
        },
      );
      localStorage.clear();
      localStorage.removeItem("token");
      keycloak.logout({ redirectUri: window.location.origin });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnIdle = (event) => {
    handleLogoutIdeal();
  };

  useIdleTimer({ timeout: 600000, onIdle: handleOnIdle, debounce: 500 });

  return (
    <QueryClientProvider client={queryClient}>
      <WaterMarkProvider>
        <Router>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            <Route
              path="/home"
              element={
                <Layout title="">
                  <Landing handleLogout={handleLogout} />
                </Layout>
              }
            />
            <Route
              path="/service"
              element={
                <Layout title="Service">
                  <Cards handleLogout={handleLogout} menu={"service"} />
                </Layout>
              }
            />
            <Route
              path="/salesPreSales"
              element={
                <Layout title="Sales PreSales">
                  <Cards handleLogout={handleLogout} menu={"salesPreSales"} />
                </Layout>
              }
            />
            <Route
              path="/DailyWorkManagement"
              element={
                <Layout title="Daily Work Management">
                  <Cards
                    handleLogout={handleLogout}
                    menu={"DailyWorkManagement"}
                  />
                </Layout>
              }
            />
            <Route
              path="/Retail-Dashboard"
              element={
                <Layout title="Live Retail" dashboardAlias="dealer_invoice">
                  <ProtectedRoute
                    element={Retail}
                    dashboardName="Live Retail"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Complaint-Dashboard"
              element={
                <Layout
                  title="Complaint Dashboard"
                  dashboardAlias="dealer_complaint"
                >
                  <ProtectedRoute
                    element={Service}
                    dashboardName="complaint"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/PowerDeck"
              element={
                <Layout title="PowerDeck" dashboardAlias="dealer_offtake">
                  <ProtectedRoute
                    element={index}
                    dashboardName="Live Offtake"
                    handleLogout={handleLogout}
                  />{" "}
                </Layout>
              }
            />
            <Route
              path="/Offtake-Dashboard"
              element={
                <Layout title="Live Offtake" dashboardAlias="dealer_offtake">
                  <ProtectedRoute
                    element={Offtake}
                    dashboardName="Live Offtake"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Stock-Dashboard"
              element={
                <Layout title="Live Stock" dashboardAlias="dealer_stocks">
                  <ProtectedRoute
                    element={Stock}
                    dashboardName="Live Stock"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Pipeline"
              element={
                <Layout
                  title="Pipeline Summary"
                  dashboardAlias="dealer_retail_pipeline"
                >
                  <ProtectedRoute
                    element={PipeLine}
                    dashboardName="Pipeline Summary"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Lead-Source"
              element={
                <Layout
                  title="Lead Source Metrics"
                  dashboardAlias="dealer_lead"
                >
                  <ProtectedRoute
                    element={LeadSource}
                    dashboardName="Lead Source Metrics"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/WSR"
              element={
                <Layout
                  title="Weekly Sales Review"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={Wsr}
                    dashboardName="WSR"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/WSR-Metrics"
              element={
                <Layout
                  title="Weekly Sales Metrics"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={WsrMetrics}
                    dashboardName="WSR"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Tqp-LostCase"
              element={
                <Layout
                  title="Top 5 Applications TQP (MTD vs LMTD)"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={TqpLostCase}
                    dashboardName="WSR"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/State-Offtake-Retails"
              element={
                <Layout
                  title="State wise Analysis of Retail & Offtake"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={StateWiseOfftake}
                    dashboardName="WSR"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Performance-Dashboard"
              element={
                <Layout
                  title="Performance Dashboard"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={ILMCVPerformance}
                    dashboardName="WSR"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Dealer-Review"
              element={
                <Layout
                  title="Dealer Review"
                  dashboardAlias="dealer_review_dashboard"
                >
                  <ProtectedRoute
                    element={DealerReview}
                    dashboardName="Dealer Review"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Dealer-Review-Upload-Data"
              element={
                <Layout
                  title="Dealer Review Upload Data"
                  dashboardAlias="dealer_review_dashboard"
                >
                  <ProtectedRoute
                    element={DealerDataUpload}
                    dashboardName="Dealer Review Upload Data"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />

            <Route
              path="/Sales-Success-Center"
              element={
                <Layout
                  title="Sales Success Center"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={SalesSuccess}
                    dashboardName="Dealer Review"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />

            <Route
              path="/Key-Accounts-Intelligence"
              element={
                <Layout title="Key Accounts Intelligence" dashboardAlias="">
                  <ProtectedRoute
                    element={Pvin}
                    dashboardName="PVIN"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Customer360"
              element={
                <Layout title="Customer360" dashboardAlias="">
                  <ProtectedRoute
                    element={Customer360}
                    dashboardName="Customer360"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Realization"
              element={
                <Layout
                  title="Realization"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={Realization}
                    dashboardName="Realization Summary"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Service-Collabax"
              element={
                <Layout
                  title="Service Collabx"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={ServiceCollabax}
                    dashboardName="Service Collabax"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />
            <Route
              path="/Dealer-Service-Collabax"
              element={
                <Layout
                  title="Dealer Service Collabax"
                  dashboardAlias="dealer_sales_service_center"
                >
                  <ProtectedRoute
                    element={DealerServiceCollabax}
                    dashboardName="Service Collabax Dealer"
                    handleLogout={handleLogout}
                  />
                </Layout>
              }
            />

            <Route
              path="/Others"
              element={
                <Layout title="Others">
                  <Cards handleLogout={handleLogout} menu={"Others"} />
                </Layout>
              }
            />

            <Route exact path="/PageNotFound" element={<PageNotFound />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </WaterMarkProvider>
    </QueryClientProvider>
  );
}

export default App;
